export const NPLUSONE_EVENT = Object.freeze({
  Ready: 'nplusone_ready',
  Completed: 'nplusone_completed',
  Skipped: 'nplusone_skipped',
  Failed: 'nplusone_failed',
  NoFill: 'nplusone_no_fill',
  AlternateRequested: 'nplusone_alternate_requested',
});

export const LIFECYCLE_REQUEST_KIND = Object.freeze({
  Alternate: 'alternate',
});

/** Publish one scoped lifecycle event on the accessible publisher window. */
export function dispatchPublisherEvent(renderEnv, name, detail) {
  const target = renderEnv?.topWindow ?? window;
  try {
    target.dispatchEvent(new target.CustomEvent(name, { detail }));
  } catch (_) {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  }
}

export function lifecycleDetail(
  placementId,
  instanceId = null,
  conversationId = null,
  requestKind = null,
) {
  return {
    instance_id: instanceId,
    placement_id: placementId,
    conversation_id: conversationId,
    ...(requestKind ? { request_kind: requestKind } : {}),
  };
}
